import { Route, RouteProps } from 'react-router';
import { Switch } from 'react-router-dom';
import { AuthenticateRoute, AnonymousRoute } from './RouteConfig';
import { routesSb } from './skyboxRoutes/SkyboxRoute';
import { routesSh } from './stubHubRoutes/StubHubRoute';
import { commonRoutes } from './commonRoutes/CommonRoute';
import { NotFound } from './NotFound';
const Routes: React.FC<RouteProps> = () => {
  return (
    <Switch>
      {[...routesSb, ...commonRoutes, ...routesSh]?.map((route) =>
        route.auth ? (
          <AuthenticateRoute
            key={route.path}
            path={route.path}
            exact={route.exact}
            component={route.component}
            allowedPermissions={route.allowedPermissions}
            redirect={route.redirect}
          />
        ) : (
          <AnonymousRoute
            key={route.path}
            path={route.path}
            exact={route.exact}
            component={route.component}
          />
        ),
      )}
      <Route component={NotFound}></Route>
    </Switch>
  );
};

export default Routes;
